"use client";
import { createContext, useContext, useEffect, useState } from 'react';
import { fetchSeatsData, SeatsData } from '@/lib/seats-api';
import { EVENT_CONFIG } from '@/lib/config';

interface SeatsContextType {
  remainingSeats: number;
  totalSeats: number;
  reservedSeats: number;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

const SeatsContext = createContext<SeatsContextType>({
  remainingSeats: EVENT_CONFIG.REMAINING_SEATS,
  totalSeats: EVENT_CONFIG.TOTAL_SEATS,
  reservedSeats: EVENT_CONFIG.TOTAL_SEATS - EVENT_CONFIG.REMAINING_SEATS,
  isLoading: false,
  error: null,
  refetch: async () => {}
});

export function SeatsProvider({ children }: { children: React.ReactNode }) {
  const [seatsData, setSeatsData] = useState<SeatsData>({
    Restantes: EVENT_CONFIG.REMAINING_SEATS,
    Totales: EVENT_CONFIG.TOTAL_SEATS,
    Reservadas: EVENT_CONFIG.TOTAL_SEATS - EVENT_CONFIG.REMAINING_SEATS
  });
  const [isLoading, setIsLoading] = useState(false); // Start with false to avoid hydration mismatch
  const [error, setError] = useState<string | null>(null);

  const loadSeatsData = async () => {
    // DISABLED: API fetching is disabled to show sold out status
    // setIsLoading(true);
    // setError(null);
    
    // try {
    //   const data = await fetchSeatsData();
    //   
    //   if (data) {
    //     setSeatsData(data);
    //     // Update global config
    //     EVENT_CONFIG.REMAINING_SEATS = data.Restantes;
    //     EVENT_CONFIG.TOTAL_SEATS = data.Totales;
    //   }
    // } catch (err) {
    //   setError('Error al cargar los datos de disponibilidad');
    //   console.error('Error loading seats data:', err);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  useEffect(() => {
    // DISABLED: API fetching is disabled to show sold out status
    // loadSeatsData();
    
    // // Refresh data every 5 minutes
    // const interval = setInterval(loadSeatsData, 5 * 60 * 1000);
    
    // return () => clearInterval(interval);
  }, []);

  return (
    <SeatsContext.Provider 
      value={{
        remainingSeats: seatsData.Restantes,
        totalSeats: seatsData.Totales,
        reservedSeats: seatsData.Reservadas,
        isLoading,
        error,
        refetch: loadSeatsData
      }}
    >
      {children}
    </SeatsContext.Provider>
  );
}

export const useSeats = () => {
  const context = useContext(SeatsContext);
  if (!context) {
    throw new Error('useSeats must be used within SeatsProvider');
  }
  return context;
}